import validate from './validate'
import visibility from './visibility'

export default {
  ...validate,
  ...visibility
}
